import axios from 'axios';
import { ConfigClient, PublicBrandingDto } from '@/apiclient/apiclient_generated';

const apiUrlSetting = import.meta.env.VITE_APIURL;
const baseUrl = !apiUrlSetting || apiUrlSetting === 'auto'
  ? window.location.origin + '/api'
  : apiUrlSetting;

export const API_URL = baseUrl + '/api';
export const WS_URL = baseUrl;

const TENANT_STORAGE_KEY = 'opsboard.tenant';

// Runtime config — populated by initConfig() before Vue mounts.
// These are mutable module bindings. Consumers MUST read them via the live ES-module binding
// (e.g. `BRANDING.appName` at call time). Do NOT destructure at import time — you'd capture
// the pre-init default and never see the values fetched from /api/config/public.
export let AUTH_MODE = '';
export let AUTH_CLIENTID = '';
export let AUTH_TENANTID = '';
export let AUTH_RETURN_URL = window.location.origin;
export let ENABLE_DEMO_FEATURES = false;
export let BRANDING: PublicBrandingDto = new PublicBrandingDto();

export async function initConfig(): Promise<void> {
  const tenant = resolveTenant();

  const client = new ConfigClient(WS_URL, axios);
  const config = await client.getPublicConfig(tenant || undefined);

  AUTH_MODE = config.authMode || 'windows';
  ENABLE_DEMO_FEATURES = config.enableDemoFeatures || false;
  if (config.azureAd) {
    AUTH_CLIENTID = config.azureAd.clientId;
    AUTH_TENANTID = config.azureAd.tenantId;
  }
  BRANDING = config.branding || new PublicBrandingDto();
  AUTH_RETURN_URL = window.location.origin;

  applyBrandingToDocument();
}

function resolveTenant(): string {
  const params = new URLSearchParams(window.location.search);
  const fromUrl = params.get('tenant')?.trim();
  if (fromUrl) {
    sessionStorage.setItem(TENANT_STORAGE_KEY, fromUrl);
    return fromUrl;
  }
  return sessionStorage.getItem(TENANT_STORAGE_KEY) || '';
}

function applyBrandingToDocument() {
  const bg = BRANDING.backgroundImageFilename;
  document.documentElement.style.setProperty(
    '--bg-image',
    bg ? `url('/${bg}')` : 'none'
  );
  if (BRANDING.appName) {
    document.title = BRANDING.appName;
  }
}
